var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{attrs:{"infoList":_vm.infoList},on:{"updateInfo":_vm.updateInfo,"createList":function($event){return _vm.startCreateHotelInfoList()},"deleted":_vm.deleted}})}
var staticRenderFns = []

export { render, staticRenderFns }